class RMSMDLocal {
  //Formato a moneda
  formatoMoneda(numero)
  {
    return "$ " + numero;
  }
  //Este es el punto de entrada para agregar un elemento
  agregarElementoOrden(
    claveProducto,
    nombreProducto,
    nombreUnidad,
    precioLista,
    cantidad,
    tiempo,
    modificadores,
    elementosPaquete,
    comentarios
  ) {
    if (elementosPaquete == null)
    {
      elementosPaquete = []
    }
    var TVentaDetalle = {
      claveProducto: claveProducto,
      nombreProducto: nombreProducto,
      nombreUnidad: nombreUnidad,
      precioLista: precioLista,
      totalFila: 0,
      cantidad: cantidad,
      tiempo: tiempo,
      modificadores: modificadores,
      elementosPaquete: elementosPaquete,
      comentarios: comentarios,
      checkSum: "",
    };
    TVentaDetalle.totalFila = TVentaDetalle.cantidad * TVentaDetalle.precioLista;
    TVentaDetalle.checkSum = this.getCheckSumTVentaDetalle(TVentaDetalle);
    var listaAfectar = this.getListaDesdeStorage();
    this.incrementaOAgregaElemento(listaAfectar, TVentaDetalle);
    this.guardarElementosEnStorage(listaAfectar);
  }

  calcularTotalOrden(elementos)
  {
    var total = 0;
    elementos.forEach((e) => {
      total += e.totalFila;
    });
    return total;
  }

  guardarElementosEnStorage(lista) {
    sessionStorage.productosSeleccionados = JSON.stringify(lista);
  }

  getCheckSumTVentaDetalle(TVentaDetalle) {
    var a = TVentaDetalle.claveProducto;
    var b = JSON.stringify(TVentaDetalle.modificadores);
    var c = JSON.stringify(TVentaDetalle.elementosPaquete);
    return a + b + c;
  }
  //Obtiene la cuenta de cuantos productos hay en la lista
  getCuentaProductosLista() {
    var l = this.getListaDesdeStorage();
    if (l.length === 0) return 0;
    var cnt = 0;
    l.forEach((e) => {
      cnt += e.cantidad;
    });
    return cnt;
  }

  getListaDesdeStorage() {
    var valorSesion = sessionStorage.productosSeleccionados;
    var listaAfectar = [];
    if (valorSesion !== undefined) {
      listaAfectar = JSON.parse(valorSesion);
    }
    return listaAfectar;
  }
  ///Limpia la lista de elementos que han sido seleccionados
  clearListaProductosSeleccionados() {
    sessionStorage.removeItem("productosSeleccionados");
  }

  incrementaOAgregaElemento(listaAfectar, TVentaDetalle) {
    var existeElemento =
      listaAfectar.filter((f) => f.checkSum === TVentaDetalle.checkSum).length >
      0;
    if (existeElemento) {
      listaAfectar
        .filter((f) => f.checkSum === TVentaDetalle.checkSum)
        .forEach((element) => {
          element.cantidad++;
        });
    } else {
      var csum = listaAfectar.push(TVentaDetalle);
    }
  }
}

export default new RMSMDLocal();
